/*
  NAVEE 定制：页面内嵌规格对比表的交互。
  - 换列：所有候选车型的数据已经渲染成 JSON，切换时只替换表头和该列的单元格，不发请求。
  - 折叠：初始限高，点按钮展开；内容本来就没超高时按钮自动隐藏。
*/
(function () {
  function initSection(root) {
    if (root.dataset.specCmpInit === '1') return;
    root.dataset.specCmpInit = '1';

    var dataEl = root.querySelector('[data-spec-cmp-data]');
    var data = { products: {}, placeholder: '—' };
    if (dataEl) {
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (err) {
        // 数据坏了就退化成纯静态表格：预设的那几列仍然是正确的。
        return;
      }
    }

    /* ----- 换列 ----- */
    root.querySelectorAll('[data-spec-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var product = data.products[select.value];
        if (!product) return;

        var col = select.dataset.specCol;
        var head = root.querySelector('.spec-comparison__head[data-spec-col="' + col + '"]');

        if (head) {
          var media = head.querySelector('[data-spec-media]');
          if (media) {
            if (product.image) {
              media.innerHTML = '<img loading="lazy" alt="">';
              var img = media.querySelector('img');
              img.src = product.image;
              img.alt = product.imageAlt || '';
            } else {
              media.innerHTML = '';
            }
          }

          var price = head.querySelector('[data-spec-price]');
          if (price) price.innerHTML = product.price || '';

          var link = head.querySelector('[data-spec-link]');
          if (link) link.href = product.url;
        }

        // 行是固定的（由参考车型决定），所以按行 key 取值，缺的填占位符。
        var specs = product.specs || {};
        root
          .querySelectorAll('.spec-comparison__cell[data-spec-col="' + col + '"]')
          .forEach(function (cell) {
            var value = specs[cell.dataset.specRow];
            cell.textContent = value && value.length ? value : data.placeholder;
          });
      });
    });

    /* ----- 折叠 / 展开 ----- */
    var scroll = root.querySelector('[data-spec-scroll]');
    var toggle = root.querySelector('[data-spec-toggle]');
    if (!scroll || !toggle) return;

    var syncToggle = function () {
      // 只有真的超出限高才需要按钮。
      var overflowing = scroll.scrollHeight - scroll.clientHeight > 2;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.hidden = !overflowing && !expanded;
    };

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        // 先把当前高度写成行内值（视觉上无变化），加上限高 class 后再清掉行内值，
        // 这样 max-height 是从具体数值过渡到限高值，能看到动画。
        scroll.style.maxHeight = scroll.scrollHeight + 'px';
        scroll.classList.add('is-clamped');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = toggle.dataset.labelMore;
        window.requestAnimationFrame(function () {
          scroll.style.maxHeight = '';
        });
        // 收起后表格顶部可能已经滚出视口，把 section 拉回来。
        root.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      } else {
        // 展开时给一个明确的高度做过渡，结束后解除限制，
        // 否则内容变化（比如换车型）后高度会被钉死。
        scroll.style.maxHeight = scroll.scrollHeight + 'px';
        scroll.classList.remove('is-clamped');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.textContent = toggle.dataset.labelLess;
        window.setTimeout(function () {
          if (toggle.getAttribute('aria-expanded') === 'true') scroll.style.maxHeight = '';
        }, 350);
      }
    });

    syncToggle();
    window.addEventListener('resize', syncToggle);
  }

  function init() {
    document.querySelectorAll('[data-spec-cmp]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 主题编辑器里改设置会重新渲染 section。
  document.addEventListener('shopify:section:load', init);
})();
